import { styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { ReactNode } from 'react'
import { Typography } from '../../text'
import { IconContext } from '@phosphor-icons/react'

type ViewSwitchItemProps = {
    label: string
    value: string
    onClick: () => void
    selected?: boolean
    leftIcon?: ReactNode
    rightIcon?: ReactNode
}

export function ViewSwitchItem({ selected, leftIcon, rightIcon, label, onClick }: ViewSwitchItemProps) {
    const iconColor = selected ? tokens.ColorIconLinkSelected : tokens.ColorIconBoldest
    return (
        <ViewSwitchItemContainer $selected={selected} onClick={onClick} role="tab">
            {leftIcon && (
                <IconContext.Provider
                    value={{
                        size: tokens.SizingIconS,
                        weight: 'bold',
                        color: iconColor,
                    }}
                >
                    {leftIcon}
                </IconContext.Provider>
            )}
            <Typography variant="link" color={selected ? tokens.ColorTextLinkSelected : tokens.ColorTextDefault} noWrap>
                {label}
            </Typography>
            {rightIcon && (
                <IconContext.Provider
                    value={{
                        size: tokens.SizingIconS,
                        weight: 'bold',
                        color: iconColor,
                    }}
                >
                    {rightIcon}
                </IconContext.Provider>
            )}
        </ViewSwitchItemContainer>
    )
}

const ViewSwitchItemContainer = styled('div', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $selected?: boolean }>(({ $selected }) => ({
    cursor: 'pointer',
    height: '32px',
    borderRadius: tokens.SizingCornerS,
    padding: `0 ${tokens.SizingSpacing100}`,
    gap: tokens.SizingSpacing100,
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: $selected ? tokens.ColorSurfaceSelectedDefault : undefined,
    boxShadow: `0 0 0 ${tokens.SizingBorderS} ${$selected ? tokens.ColorBorderSelectedDefault : 'transparent'}`,
    boxSizing: 'border-box',
    '&:hover': {
        ...(!$selected ? { backgroundColor: tokens.ColorSurfaceHover } : {}),
    },
}))
